const dev = "http://localhost:8000";
const prod = "https://techokids.onrender.com";
export const base_route = prod;
